import { Card, ProgressBar } from 'react-bootstrap'
import { LazyAvatar } from '@/components/common/LazyAvatar'
import iconPlaceholder from '@/assets/images/media-buying/icon-placeholder.png'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import { Link } from 'react-router-dom'
import { isEmpty } from 'lodash'

export const PhoneFormMockup = ({
    scrollableRef,
    current,
    direction,
    pageIcon,
    pageTitle,
    contextCard,
    headline,
    description,
    thankYouPage,
    privacyPolicyUrl,
    legalContent,
    progress,
    getButtonForQuestion,
    followUpActionText,
}) => {
    return (
        <div className="d-flex tw:justify-content-center tw:align-items-start tw:overflow-x-hidden">
            <div className="phone-form-mockup border tw:border-gray-700 tw:rounded d-flex flex-column tw:text-dark tw:pt-8">
                {/* Scrollable Content Wrapper */}
                <div
                    ref={scrollableRef}
                    className="scrollable-content flex-grow-1"
                    style={{
                        overflowY: 'auto',
                        paddingBottom: '20px',
                        scrollbarWidth: 'none' /* Firefox */,
                        msOverflowStyle: 'none' /* IE and Edge */,
                    }}
                >
                    {/* Header */}
                    <div className="d-flex align-items-center flex-column mx-auto pt-2 ps-3 pe-3 w-100">
                        <Card className="d-flex align-items-center mx-auto shadow-sm tw:px-2 tw:pt-4 tw:mb-0 tw:pb-3 bg-white border-0 w-100 tw:mt-8 position-relative">
                            <div className="position-absolute" style={{ top: '-25px' }}>
                                <LazyAvatar
                                    src={pageIcon || iconPlaceholder}
                                    placeholder={iconPlaceholder}
                                    alt="Page image"
                                />
                            </div>
                            <span className="light-gray-text mt-3 mb-1 fs-6 mock-form-title-block">
                                {pageTitle || 'Connected Page Title'}
                            </span>

                            {/* Only show header context information if NOT on thank you page */}
                            {!current.thankyou && (
                                <>
                                    {/* Use contextCard data if available, otherwise fallback to props */}
                                    {contextCard?.title && (
                                        <div className="tw:text-base tw:text-primary tw:max-w-[200px] tw:truncate tw:overflow-hidden tw:whitespace-nowrap">
                                            {contextCard.title}
                                        </div>
                                    )}
                                    {!contextCard?.title && headline && (
                                        <div className="tw:text-base tw:text-primary tw:max-w-[200px] tw:truncate tw:overflow-hidden tw:whitespace-nowrap">
                                            {headline}
                                        </div>
                                    )}

                                    {/* Use contextCard content if available */}
                                    {contextCard?.content && contextCard.style === 'LIST_STYLE' && (
                                        <div className="tw:self-start tw:pt-1">
                                            <div className="">
                                                <ul className="tw:list-disc tw:pl-5 tw:text-sm tw:text-gray-700">
                                                    {contextCard.content.slice(0, 3).map((item, idx) => (
                                                        <li key={idx}>{item}</li>
                                                    ))}
                                                </ul>
                                                {contextCard.content.length > 3 && (
                                                    <div className="tw:mt-2 tw:text-gray-500 tw:cursor-pointer tw:flex tw:justify-center">
                                                        Show more...
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                    {contextCard?.content && contextCard.style !== 'LIST_STYLE' && (
                                        <div className="tw:text-md tw:pt-1 tw:text-primary tw:max-w-[220px] tw:max-h-[220px] tw:overflow-hidden tw:line-clamp-[10]">
                                            {Array.isArray(contextCard.content)
                                                ? contextCard.content.join(' ')
                                                : contextCard.content}
                                        </div>
                                    )}

                                    {/* Fallback to description props if no contextCard */}
                                    {!contextCard?.content && !isEmpty(description) && description?.paragraph && (
                                        <div className="tw:text-md tw:pt-1 tw:text-primary tw:max-w-[220px] tw:max-h-[220px] tw:overflow-hidden tw:line-clamp-[10]">
                                            {description.paragraph}
                                        </div>
                                    )}
                                    {!contextCard?.content && !isEmpty(description?.list) && (
                                        <div className="tw:self-start tw:pt-1">
                                            <div className="">
                                                <ul className="tw:list-disc tw:pl-5 tw:text-sm tw:text-gray-700">
                                                    {description.list.slice(0, 3).map((item, idx) => (
                                                        <li key={idx}>{item}</li>
                                                    ))}
                                                </ul>
                                                {description.list.length > 3 && (
                                                    <div className="tw:mt-2 tw:text-gray-500 tw:cursor-pointer tw:flex tw:justify-center">
                                                        Show more...
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </>
                            )}

                            {current.thankyou && (
                                <>
                                    <div className="text-dark2 fw-bold pt-1 pb-2 tw:max-w-[220px] text-center">
                                        {thankYouPage?.headline || current.thankYouMessage || "Thanks, you're all set."}
                                    </div>
                                    <div className="text-muted-darkened ps-2 pt-1 fs-8 tw:max-w-[220px] overlfow-ellipsis">
                                        {thankYouPage?.description ||
                                            current.description ||
                                            'You can visit our website or exit from the form now.'}
                                    </div>
                                    <hr className="hr-horizontal w-100 bg-black mt-3" />
                                    <div className="tw:flex flex-grow-1  tw:items-center">
                                        <i className="icon tw:pr-1 ">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="12"
                                                height="12"
                                                fill="currentColor"
                                                className="bi bi-info-circle text-muted"
                                                viewBox="0 0 16 16"
                                            >
                                                <path d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zM8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0z" />
                                                <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 .875-.252 1.02-.598l.088-.416c.076-.347.223-.44.548-.525l.088-.38-1.106-.287.738-3.468c.194-.897-.105-1.319-.808-1.319-.545 0-.875.252-1.02.598l-.088.416z" />
                                                <circle cx="8" cy="4.5" r="1" />
                                            </svg>
                                        </i>
                                        <span className="text-muted fs-9 tw:items-center">
                                            You successfully submitted your responses
                                        </span>
                                    </div>
                                </>
                            )}
                        </Card>
                    </div>

                    <div
                        className={`${current.thankyou ? 'thank-you-center' : ''} flex-grow-1 position-relative  px-3 overflow-hidden`}
                    >
                        <TransitionGroup component={null}>
                            <CSSTransition
                                key={current.id}
                                classNames={direction === 'forward' ? 'question-slide' : 'question-slide-reverse'}
                                timeout={{ enter: 180, exit: 50 }}
                            >
                                <>
                                    {current.type === 'contact_info' && (
                                        <Card
                                            className="d-flex text-start shadow-sm px-4 pt-4 pb-4 bg-white border-0 w-100 mt-8 position-relative"
                                            style={{ borderRadius: '12px' }}
                                        >
                                            <div className="d-flex align-items-center mb-3">
                                                <span className="text-dark2 fw-bold">Contact information</span>
                                                <i
                                                    className="bi bi-info-circle text-muted ms-2"
                                                    style={{ fontSize: '14px' }}
                                                ></i>
                                            </div>
                                            {current.fields &&
                                                current.fields.map((field, index) => (
                                                    <div key={field.id || index} className="mb-3">
                                                        <label className="text-start d-block dark-gray-text fw-medium mb-1">
                                                            {field.type === 'EMAIL' && 'Email'}
                                                            {field.type === 'FULL_NAME' && 'Full name'}
                                                            {field.type === 'POST_CODE' && 'Post code'}
                                                            {field.type === 'PHONE' && 'Phone'}
                                                            {field.type === 'STREET_ADDRESS' && 'Street address'}
                                                            {field.type === 'CITY' && 'City'}
                                                            {field.type === 'STATE' && 'State'}
                                                            {field.type === 'PROVINCE' && 'Province'}
                                                            {field.type === 'COUNTRY' && 'Country'}
                                                            {field.type === 'ZIP_CODE' && 'Zip code'}
                                                            {field.type === 'DATE_OF_BIRTH' && 'Date of birth'}
                                                            {field.type === 'GENDER' && 'Gender'}
                                                            {field.type === 'MARITAL_STATUS' && 'Marital status'}
                                                            {field.type === 'NATIONALITY' && 'Nationality'}
                                                            {field.type === 'COMPANY' && 'Company'}
                                                            {field.type === 'JOB_TITLE' && 'Job title'}
                                                            {field.type === 'DEPARTMENT' && 'Department'}
                                                            {field.type === 'EMPLOYEE_COUNT' && 'Employee count'}
                                                            {field.type === 'NATIONAL_ID_NUMBER' &&
                                                                'National ID number'}
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control tw:!bg-transparent"
                                                            placeholder="Enter your answer."
                                                            style={{
                                                                border: 'none',
                                                                borderBottom: '1px solid #dee2e6',
                                                                outline: 'none',
                                                            }}
                                                        />
                                                    </div>
                                                ))}
                                        </Card>
                                    )}
                                    {!current.privacy &&
                                        !current.thankyou &&
                                        current.type !== 'contact_info' &&
                                        current.options &&
                                        current.options.length > 0 && (
                                            <Card className="d-flex text-start shadow-sm px-4 pt-4 pb-5 bg-white border-0 w-100 mt-8 position-relative">
                                                <label className="text-start d-block dark-gray-text fw-bold mb-3">
                                                    {current.label || current.question}
                                                </label>
                                                <div className="d-flex flex-column gap-2">
                                                    {current.options.map((option, index) => (
                                                        <button
                                                            key={index}
                                                            type="button"
                                                            className="btn btn-outline-secondary rounded-pill py-2 px-4 text-start border-2"
                                                            style={{
                                                                backgroundColor: '#f8f9fa',
                                                                borderColor: '#dee2e6',
                                                                color: '#495057',
                                                            }}
                                                        >
                                                            {typeof option === 'object' ? option?.value : option}
                                                        </button>
                                                    ))}
                                                </div>
                                            </Card>
                                        )}
                                    {!current.privacy &&
                                        !current.thankyou &&
                                        current.type !== 'contact_info' &&
                                        (!current.options || current.options.length === 0) && (
                                            <Card className="d-flex text-start shadow-sm px-4 pt-4 pb-5 bg-white border-0 w-100 mt-8 position-relative">
                                                <label className="text-start d-block dark-gray-text fw-bold mb-1">
                                                    {current.label || current.question}
                                                </label>
                                                <input
                                                    type="text"
                                                    className="mt-1 dark-gray-text border-bottom border-gray-300"
                                                    placeholder="Enter your answer"
                                                />
                                            </Card>
                                        )}
                                    {current.privacy && (
                                        <Card className="d-flex text-start shadow-sm px-4 pt-4 pb-4 bg-white border-0 w-100 mt-8 position-relative">
                                            {/* Custom Disclaimer */}
                                            {current.showCustomDisclaimer && current.customDisclaimer && (
                                                <>
                                                    <div className="text-dark2 fw-medium mb-2">
                                                        {current.customDisclaimer}
                                                    </div>
                                                    {current.disclaimerText && (
                                                        <div className="text-muted mb-3 fs-9">
                                                            {current.disclaimerText}
                                                        </div>
                                                    )}
                                                </>
                                            )}

                                            <div className="text-dark2 fw-medium mt-2 mb-2">Privacy Policy</div>
                                            <div className="text-muted mb-2 fs-9">
                                                By clicking Submit, you agree to send your info to{' '}
                                                {pageTitle + ' ' || 'this page '}
                                                who agrees to use it according to their privacy policy. Facebook will
                                                also use it subject to our Data Policy, including to auto-fill forms for
                                                ads.
                                            </div>

                                            {/* Custom Notices */}
                                            {current.customNotices && (
                                                <div className="text-muted mb-2 fs-9">{current.customNotices}</div>
                                            )}

                                            <div className="facebook_html_link_style mb-1 fs-9 fw-bold">
                                                <Link
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    to={current.facebookUrl || 'https://www.facebook.com/policy.php'}
                                                >
                                                    View Facebook Data Policy
                                                </Link>
                                            </div>
                                            <div className="facebook_html_link_style mb-1 fs-9 fw-bold">
                                                <Link
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    to={
                                                        privacyPolicyUrl ||
                                                        legalContent?.privacy_policy?.url ||
                                                        current.privacyUrl
                                                    }
                                                >
                                                    {legalContent?.privacy_policy?.link_text ||
                                                        current.linkText ||
                                                        `${pageTitle || 'this page'}'s Privacy Policy`}
                                                </Link>
                                            </div>

                                            {/* Consents */}
                                            {current.consents &&
                                                current.consents.length > 0 &&
                                                current.consents.some((c) => c.text) && (
                                                    <div className="mt-3 align-items-center">
                                                        {current.consents
                                                            .filter((c) => c.text)
                                                            .map((consent, index) => (
                                                                <div
                                                                    key={consent.id || index}
                                                                    className="d-flex align-items-center mb-2"
                                                                >
                                                                    <input
                                                                        type="checkbox"
                                                                        className="me-2 mt-1"
                                                                        style={{ minWidth: '14px' }}
                                                                    />
                                                                    <div className="text-muted fs-9">
                                                                        {consent.text}
                                                                        {!consent.required && (
                                                                            <span className="text-muted">
                                                                                {' '}
                                                                                (Optional)
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            ))}
                                                    </div>
                                                )}
                                        </Card>
                                    )}
                                </>
                            </CSSTransition>
                        </TransitionGroup>
                    </div>
                </div>
                <ProgressBar now={progress} variant="primary" style={{ height: '4px' }} />
                {current.thankyou ? (
                    <div className="d-flex justify-content-center px-2 tw:pt-2 tw:pb-6">
                        <button
                            className="btn tw:!bg-blue-500 px-2 fw-semibold w-100 tw:h-[40px] "
                            style={{
                                borderRadius: '8px',
                                fontSize: '16px',
                            }}
                        >
                            <span className="overflow-ellipse">
                                {thankYouPage?.call_to_action?.link_caption ||
                                    followUpActionText ||
                                    current.websiteButtonText ||
                                    'View website'}
                            </span>
                        </button>
                    </div>
                ) : (
                    <img src={getButtonForQuestion} alt="Continue" className="p-2 pb-4" style={{ height: '70px' }} />
                )}
            </div>
        </div>
    )
}
